<template>
  <div>
    <loading :active.sync="isLoading" :loader="'dots'" :color="'#FFF'" :background-color="'#000'" :can-cancel="false" :is-full-page="true"></loading>
    <div>
      <b-modal
        @hide="closeModal"
        ref="companyCalendarModal"
        :title="title"
        size="xl"
        dialog-class="calendar-modal-dialog"
        body-class="calendar-modal-body"
        footer-class="calendar-modal-footer"
      >
        <div class="q-with-b">
          <button class="btn btn-info" style="margin-left: 10px;" @click="openOptionModal">{{ $t('休日一括追加') }}</button>
          <div class="row">
            <template v-for="index in 12">
              <company-calendar-q-date
                :key="index"
                ref="companyCalendars"
                v-model="innerHolidays"
                minimal
                multiple
                mask="YYYY-MM-DD"
                :first-day-of-week="displayDayOfWeek"
                :options="editableRange"
                @navigation="navigateCalendar($event, index)"
                class="company-calendar"
              />
            </template>
          </div>
        </div>
        <template v-slot:modal-footer>
          <div class="d-flex justify-content-center align-items-center">
            <button class="btn-content btn-light flex-shrink-1" @click="reset">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M13.5 2c-5.288 0-9.649 3.914-10.377 9h-3.123l4 5.917 4-5.917h-2.847c.711-3.972 4.174-7 8.347-7 4.687 0 8.5 3.813 8.5 8.5s-3.813 8.5-8.5 8.5c-3.015 0-5.662-1.583-7.171-3.957l-1.2 1.775c1.916 2.536 4.948 4.182 8.371 4.182 5.797 0 10.5-4.702 10.5-10.5s-4.703-10.5-10.5-10.5z"/>
              </svg>
              {{ $t('リセット') }}
            </button>
            <button class="btn-content btn-light flex-shrink-1 ml-3" @click="closeModal">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"/>
              </svg>
              {{ $t('キャンセル') }}
            </button>
            <button class="btn-content btn-success flex-shrink-1 ml-3" variant="success" @click="register">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M16 11h5l-9 10-9-10h5v-11h8v11zm1 11h-10v2h10v-2z"/>
              </svg>
              {{ $t('登録') }}
            </button>
          </div>
        </template>
      </b-modal>
      <b-modal @hide="closeOptionModal" ref="optionModal" :title="$t('休日一括追加')" size="lg">
        <div class="q-with-b">
          <div class="row">
            <div class="col">
              <q-select
                v-model="option.years"
                multiple
                :options="calendarOptionYears"
                use-chips
                stack-label
                :label="$t('年（空欄であれば毎年）')"
                style="max-width: 100%;"
              >
                <template v-slot:prepend>
                  <q-icon name="event" />
                </template>
                <template v-if="option.years.length" v-slot:append>
                  <q-icon name="cancel" @click.stop="option.years = []" class="cursor-pointer" />
                </template>
              </q-select>
            </div>
            <div class="col">
              <q-select
                v-model="option.months"
                multiple
                :options="calendarOptionMonths"
                use-chips
                stack-label
                :label="$t('月（空欄であれば毎月）')"
                style="max-width: 100%;"
              >
                <template v-slot:prepend>
                  <q-icon name="event" />
                </template>
                <template v-if="option.months.length" v-slot:append>
                  <q-icon name="cancel" @click.stop="option.months = []" class="cursor-pointer" />
                </template>
              </q-select>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <q-select
                v-model="option.dayOfWeeks"
                multiple
                :options="calendarOptionDayOfWeeks"
                use-chips
                stack-label
                :label="$t('曜日（空欄であれば全曜日）')"
                style="max-width: 100%;"
              >
                <template v-slot:prepend>
                  <q-icon name="event" />
                </template>
                <template v-if="option.dayOfWeeks.length" v-slot:append>
                  <q-icon name="cancel" @click.stop="option.dayOfWeeks = []" class="cursor-pointer" />
                </template>
              </q-select>
            </div>
            <div class="col">
              <q-toggle
                v-model="option.isApplyHoliday"
                :label="$t('祝日を適用する')"
                class="absolute"
                style="top: 50%; transform: translate(0, -50%);"
              />
            </div>
          </div>

        </div>
        <template v-slot:modal-footer>
          <div class="d-flex justify-content-center align-items-center">
            <button class="btn-content btn-light flex-shrink-1" @click="closeOptionModal">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"/>
              </svg>
              {{ $t('キャンセル') }}
            </button>
            <button class="btn-content btn-secondary flex-shrink-1 ml-3" @click="setOptionHoliday">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/>
              </svg>
              {{ $t('追加') }}
            </button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import moment from 'moment/moment'
import { mapGetters } from 'vuex'
import { QDate } from 'quasar'

// QDateで日付選択時にカレンダーの年月が遷移するのを防ぐ
const CompanyCalendarQDate = QDate.extend({
  computed: {
    lastEmitValue: {
      get() {
        return this.value
      },
      set() {
        void 0
      },
    },
  },
})

const calendarCount = 12
const startObj = moment().startOf('year')
// Allow users to edit past year holidays
const startDate = '19750101'
const yearRange = 30
const endObj = startObj.clone().add(yearRange, 'years').endOf('year')
const endDate = endObj.format('YYYY-MM-DD')
const defaultOption = {
  years: [],
  months: [],
  dayOfWeeks: [],
  isApplyHoliday: false,
}
const startYear = startObj.year()
const years = Array.from({length: yearRange}, (_, i) => startYear + i)
const months = Array.from({length: 12}, (_, i) => i)
const dayOfWeekNames = ['日', '月', '火', '水', '木', '金', '土']
const dayOfWeeks = Array.from({length: 7}, (_, i) => i)
const defaultHolidayDayOfWeeks = [0, 6] // 日, 土

export default {
  components: {
    CompanyCalendarQDate,
  },
  props: {
    title: String,
    holidays: Array,
    displayMonth: Number,
    displayDayOfWeek: Number,
    countryCode: String,
  },
  data() {
    return {
      isLoading: false,
      isNavigatingCalendar: false,
      innerHolidays: [],
      option: cloneDeep(defaultOption),
    }
  },
  methods: {
    openModal() {
      if (this.$props.holidays !== null) {
        // 編集可能範囲外の日付を取り除いたものを設定する
        this.innerHolidays = cloneDeep(this.$props.holidays).filter(date => this.editableRange(date))
      } else {
        this.innerHolidays = this.getOptionHolidays(years, months, defaultHolidayDayOfWeeks)
      }

      this.$refs.companyCalendarModal.show()

      // モーダルの表示待ち
      this.$nextTick(function() {
        // 表示開始月を考慮
        this.navigateCalendar({year: startObj.year(), month: this.$props.displayMonth}, 1)
      })
    },
    closeModal() {
      this.innerHolidays = []
      this.$refs.companyCalendarModal.hide()
    },
    editableRange(date) {
      return startDate <= date && date <= endDate
    },
    navigateCalendar(event, index) {
      // イベントの重複回避
      if (this.isNavigatingCalendar) return
      this.isNavigatingCalendar = true

      // 左上のカレンダーの年月を求める
      const monthDiff = index - 1
      const calendarYm = moment({y: event.year, M: event.month - 1}).subtract(monthDiff, 'month')

      // 各カレンダーの年月を設定する
      for (let i = 0; i < this.calendarCount; i++) {
        this.$refs.companyCalendars[i].setCalendarTo(calendarYm.year(), calendarYm.month() + 1)
        calendarYm.add(1, 'month')
      }

      // 操作対象のカレンダー月の描画待ち
      this.$nextTick(() => {
        // この関数による各カレンダー月の描画待ち
        this.$nextTick(() => {
          this.isNavigatingCalendar = false
        })
      })
    },
    reset() {
      this.innerHolidays = []
    },
    register() {
      this.$emit('register', this.innerHolidays)
    },
    openOptionModal() {
      this.$refs.optionModal.show()
    },
    closeOptionModal() {
      this.option = cloneDeep(defaultOption)
      this.$refs.optionModal.hide()
    },
    async getCountryHolidays() {
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/country_holiday`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: {
              countryCode: this.$props.countryCode,
            },
          }
        )
        // 編集範囲外の日付を取り除いた、配列を返す
        return res.data.holidays.map(v => v.date).filter(date => this.editableRange(date))
      } catch (e) {
        // Do nothing
      }
      return []
    },
    getOptionHolidays(optionYears, optionMonths, optionDayOfWeeks) {
      // 年・月・曜日いずれの設定があればルールに沿う日付の配列を生成する
      return optionYears.flatMap(y => optionMonths.flatMap(m => {
          const tmpHolidays = []
          const tmpDate = moment({year: y, month: m})
          while (tmpDate.month() === m) {
            if (optionDayOfWeeks.indexOf(tmpDate.days()) !== -1) {
              tmpHolidays.push(tmpDate.format('YYYY-MM-DD'))
            }
            tmpDate.add(1, 'days')
          }
          return tmpHolidays
        })
      )
    },
    async setOptionHoliday() {
      this.isLoading = true

      const hasOptionYears = Boolean(this.option.years.length)
      const optionYears = hasOptionYears ? this.option.years.map(v => v.value) : years
      const hasOptionMonths = Boolean(this.option.months.length)
      const optionMonths = hasOptionMonths ? this.option.months.map(v => v.value) : months
      const hasOptionDayOfWeeks = Boolean(this.option.dayOfWeeks.length)
      const optionDayOfWeeks = hasOptionDayOfWeeks ? this.option.dayOfWeeks.map(v => v.value) : dayOfWeeks
      const hasAnyOption = hasOptionYears || hasOptionMonths || hasOptionDayOfWeeks

      const optionCountryHolidays = this.option.isApplyHoliday ? await this.getCountryHolidays() : []
      const optionHolidays = hasAnyOption ? this.getOptionHolidays(optionYears, optionMonths, optionDayOfWeeks) : []

      // 重複を削除してセットする
      this.innerHolidays = [...new Set([...this.innerHolidays, ...optionHolidays, ...optionCountryHolidays])]

      this.isLoading = false
      this.closeOptionModal()
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
    calendarCount() {
      return calendarCount
    },
    calendarOptionYears() {
      return years.map(v => ({
        label: v + this.$t('年'),
        value: v,
      }))
    },
    calendarOptionMonths() {
      return months.map(v => ({
        label: (v + 1) + this.$t('月'),
        value: v,
      }))
    },
    calendarOptionDayOfWeeks() {
      return dayOfWeeks.map(v => ({
        label: this.$t(dayOfWeekNames[v] + '曜日'),
        value: v,
      }))
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/_modal.scss";
@import "../assets/styles/_callout.scss";

svg {
  fill: currentColor;
  height: 1.3rem;
}

::v-deep {
  .modal {
    &-header {
      padding: 20px;
      border-bottom: none;
    }

    &-body {
      padding: 0 20px;
    }

    &-footer {
      padding: 20px;
      border-top: none;
    }
  }

  .calendar-modal {
    &-dialog {
      max-width: 952px;
    }

    &-body {
      padding: 0 10px;
    }

    &-footer {
      margin-top: -10px;
    }
  }
}

.company-calendar {
  margin: 10px;
}
</style>
